export default "__VITE_ASSET__BkNFkhHH__"